<script>
import { mapActions } from 'vuex'

export default {
  name: 'DeleteCategoryModal',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    canDelete() {
      return true
    },
    title() {
      if (this.canDelete) {
        return 'Delete Category Tree'
      }

      return 'Important'
    },
  },
  methods: {
    ...mapActions('categoriesTree', ['deleteCategoryTree']),
    async onDeleteClick() {
      const { name, id } = this.category

      this.loading = true

      const response = await this.deleteCategoryTree(id)

      this.$notifier({
        response,
        successMsg: `${name} category has been successfully deleted`,
      }).then(() => {
        this.$modal.self.hide()
        this.$router.replace({ name: 'product-category-trees' })
      })
      this.loading = false
    },
  },
}
</script>

<template>
  <base-modal :state-modal="true">
    <state-modal-dialog :title="title">
      <el-icon
        slot="icon"
        name="warning"
      />
      <el-icon
        slot="subicon"
        name="delete"
      />
      <template v-if="canDelete">
        <div slot="message">
          Are you sure you wish to delete this Category Tree?
        </div>
        <div class="modal__footer">
          <el-button
            type="danger"
            :loading="loading"
            :disabled="loading"
            class="el-button--wide"
            @click="onDeleteClick"
          >
            Delete Category Tree
          </el-button>
        </div>
      </template>
      <div
        v-else
        slot="message"
      >
        Category Tree cannot be deleted because it is in use with at
        least one Provider.
      </div>
    </state-modal-dialog>
  </base-modal>
</template>
